import fetchAPI from '../fetchAPI';

import { useQuery } from '@tanstack/react-query';

export const useCustomValues = (locationId?: string, syncWithCore?: boolean) => {
  return useQuery({
    queryKey: ['custom-values', locationId],
    queryFn: async () => {
      const response: iResponse<CustomValues[]> =
        await fetchAPI({
          method: 'GET',
          route: 'core/custom-values',
          queryString: `locationId=${locationId}&syncWithCore=${syncWithCore ? true : false}`,
        });

      return response;
    },
    enabled: !!locationId // Query will only run if locationId is provided
  });
};

export default useCustomValues;
